import { render, staticRenderFns } from "./previewTemplate.vue?vue&type=template&id=50d927a0&scoped=true&"
import script from "./previewTemplate.vue?vue&type=script&lang=js&"
export * from "./previewTemplate.vue?vue&type=script&lang=js&"
import style0 from "./previewTemplate.vue?vue&type=style&index=0&id=50d927a0&prod&lang=scss&"
import style1 from "./previewTemplate.vue?vue&type=style&index=1&id=50d927a0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d927a0",
  null
  
)

export default component.exports